import React, { useState } from "react";
import ReactPlayer from "react-player";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

const VIMEO_BASE_URL = "https://vimeo.com/";

const videos = [
  { display: "Why an Orthodontist?", id: 40668464 },
  { display: "What to Eat While Wearing Braces", id: 40747848 },
  {
    display: "Everyone Deserves Straight Teeth and a Beautiful Smile",
    id: 40619467
  },
  { display: "Brushing and Flossing With Braces", id: 40747736 },
  {
    display: "Braces Are Far More Attractive Than Crooked Teeth",
    id: 40747918
  },
  { display: "Braces Are Affordable and Convenient", id: 40669722 }
];

export const FAQVideo = () => {
  const [currentVideoId, setCurrentVideoId] = useState(
    videos[0].id.toString()
  );

  return (
    <Container className="content">
      <Row>
        <Col>
          <h1>Frequently Asked Questions</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          {videos.map(video => (
            <div key={video.id}>
              <button
                type="button"
                className="faqvideo-link"
                onClick={() => setCurrentVideoId(video.id.toString())}
              >
                <FontAwesomeIcon icon={faQuestionCircle} /> {video.display}
              </button>
            </div>
          ))}
          <br />
        </Col>
        <Col>
          <ReactPlayer
            url={`${VIMEO_BASE_URL}${currentVideoId}`}
            className="videoPlayer"
            controls
            light={false}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <br />
          <br />
        </Col>
      </Row>
    </Container>
  );
};
